import { FETCHING_ERROR, FETCHING_OF, FETCHING_REFETCH, FETCHING_START, FETCHING_SUCCESS_ADMIN, FETCHING_SUCCESS_ARES, FETCHING_SUCCESS_COLLECTOR, FETCHING_SUCCESS_COLLECTOR_PAYMENTS, FETCHING_SUCCESS_CUSTOMER, FETCHING_SUCCESS_CUSTOMER_PAYMENTS, FETCHING_SUCCESS_USER } from "../actionTypes/actionTypes";


export const initialState = {
    loading: false,
    areas : [],
    adminNumber : null,
    user : {},
    collectors : [],
    collectorPayments : [],
    customers : [],
    payments : [],
    reFetch : false,
    error : false,
};


export const globalReducer =(state,action)=> {
    switch(action.type){
        case FETCHING_START :
            return {
                ...state,
                loading:true,
            };
        case FETCHING_SUCCESS_CUSTOMER :
            return {
                ...state,
                loading:false,
                customers : action.payload,
            };
        case FETCHING_SUCCESS_ARES :
            return {
                ...state,
                loading:false,
                areas : action.payload,
            };
        case FETCHING_SUCCESS_COLLECTOR :
            return {
                ...state,
                loading:false,
                collectors : action.payload,
            };
        case FETCHING_SUCCESS_COLLECTOR_PAYMENTS :
            return {
                ...state,
                loading:false,
                collectorPayments : action.payload,
            };
        case FETCHING_SUCCESS_CUSTOMER_PAYMENTS :
            return {
                ...state,
                loading:false,
                payments : action.payload,
            };
        case FETCHING_SUCCESS_USER :
            return {
                ...state,
                loading:false,
                user : action.payload,
            };
        case FETCHING_SUCCESS_ADMIN :
            return {
                ...state,
                loading:false,
                adminNumber : action.payload,
            };
        case FETCHING_OF :
            return {
                ...state,
                loading:false,
                reFetch : false,
            };
        case FETCHING_REFETCH :
            return {
                ...state,
                reFetch : action.reFetch,
            };
        case FETCHING_ERROR :
            return {
                ...state,
                loading:false,
                error : true
            };
        default: 
        return state;
}
};